module.exports = __webpack_public_path__ + "static/media/toc-mockup-1.8f08e741.jpg";